module.exports = __webpack_public_path__ + "static/media/deities1.cce51122.jpg";